import React from "react";

/**
 * Brand logo for ALLES GEREGELT.
 *
 * Variants:
 *   - "full"  → icon + wordmark + tagline (default)
 *   - "icon"  → icon-only (square), good for sidebars, avatars, favicons
 *   - "mark"  → icon-only with tight crop (no extra square padding)
 *
 * Tone:
 *   - "light" (default) → for light/paper backgrounds. Uses the original navy/gold artwork.
 *   - "dark"            → for dark sidebars/heroes. Navy strokes/text are recolored to cream.
 *
 * The source files live in /app/frontend/public so they are served as-is by the static handler.
 */
const SRC = {
  full: {
    light: "/logo-full.png",
    dark: "/logo-full-dark.png",
  },
  icon: {
    light: "/logo-icon.png",
    dark: "/logo-icon.png", // icon uses gold + outlined shape — readable on both tones
  },
  mark: {
    light: "/logo-icon-trimmed.png",
    dark: "/logo-icon-trimmed.png",
  },
};

export default function Logo({
  variant = "full",
  tone = "light",
  className = "",
  alt = "ALLES GEREGELT.",
  ...rest
}) {
  const src = (SRC[variant] || SRC.full)[tone] || SRC.full.light;
  return (
    <img
      src={src}
      alt={alt}
      data-testid={`brand-logo-${variant}`}
      loading="eager"
      decoding="async"
      className={`select-none ${className}`}
      {...rest}
    />
  );
}
